import Axios from 'axios'

export default {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    sendClientMessage: async ({ commit }, payload) => {
      commit('setLoading')
      await Axios.post(process.env.VUE_APP_API_URL_CONTACT, payload)
        .then(res => {
          if (res.data.success) {
            commit('setLoading')
            commit('setSnackAlert', {
              status: true,
              success: true,
              error: false,
              message: 'Message envoyé.'
            });
          } else throw new Error(res.data);
        }
        ).catch(error => {
          console.log(error)
          commit('setLoading')
          commit('clearError')
          commit('setSnackAlert', {
            status: true,
            success: false,
            error: true,
            message: 'Erreur de connexion avec le serveur. réssayer plus tard.'
          });
        })
    },
  }
}
